<div class="download-button-container">
  <app-button
    (click)="downloadTemplate()"
    [text]="'LABELS.DOWNLOAD'"
  ></app-button>
</div>
